import { autoinject } from 'aurelia-dependency-injection';
import { DialogController } from 'aurelia-dialog';

@autoinject()
export class CustomerNumberErpDialog {
  protected customerName = '';
  protected value = '';

  constructor(protected controller: DialogController) {}

  protected activate() {}

  protected confirm() {
    if (!this.value) return;
    void this.controller.ok(this.value.trim());
  }

  protected cancel() {
    void this.controller.cancel();
  }
}
